export default __webpack_public_path__ + "images/2b0d95be596aecdec0508bcf5b6e6fd7.svg";